import classNames from 'classnames';
import React from 'react';
import s from './index.module.scss';

function BrandButton({ disabled = false, type = 'button', animateButton = false, ...otherProps }) {
	return (
		<button
			className={classNames(s.brandButton, animateButton && s.brandButton__animate)}
			type={type}
			disabled={disabled}
			{...otherProps}
		>
			<span className={s.brandButtonContent}>{otherProps.children}</span>
		</button>
	);
}

export default BrandButton;
